module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-plan"
  }, [_c('table', {
    staticClass: "d-table d-table__stue"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "do-container"
  }, [_c('div', {
    staticClass: "do-container__left"
  }, [_c('DDropdown', {
    staticClass: "title--grey"
  }, [_c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.createCalendars('kindergarten')
      }
    }
  }, [_vm._v("\n                  Opret stuer\n                ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsCreateOpeningHours(true)
      }
    }
  }, [_vm._v("\n                  Åbningstider\n                ")])])]), _vm._v("\n            Uge " + _vm._s(_vm.currentWeek) + "\n            "), _c('DutyScheduleNav', {
    on: {
      "today": function($event) {
        return _vm.$emit('today')
      },
      "next": function($event) {
        return _vm.$emit('next')
      },
      "prev": function($event) {
        return _vm.$emit('prev')
      }
    }
  }), _vm._v(" "), _c('CopyMultipleCalendarsCopy', {
    attrs: {
      "initCopyDate": _vm.date
    },
    on: {
      "submit": function($event) {
        return _vm.copyCals($event)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "copy-button-title"
    },
    slot: "copy-button-title"
  }, [_vm._v("Kopier")])])], 1), _vm._v(" "), (_vm.isEventsLoading) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return _c('th', {
      key: day.dateFormatted
    }, [_vm._v(_vm._s(day.dateFormatted))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.calendars), function(calendar) {
    return _c('DutyScheduleCalendar', {
      attrs: {
        "calendar": calendar,
        "date": _vm.date,
        "days": _vm.days,
        "events": _vm.events,
        "usersCalIdsHash": _vm.usersCalIdsHash,
        "eventsInHash": _vm.eventsInHash,
        "theCreateEventObj": _vm.theCreateEventObj,
        "userNorms": _vm.userNorms,
        "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
        "openingHours": _vm.openingHours
      },
      on: {
        "createSubject": function($event) {
          return _vm.$emit('createSubject', $event)
        },
        "createEvent": function($event) {
          return _vm.$emit('createEvent', $event)
        },
        "editEvent": function($event) {
          return _vm.$emit('editEvent', $event)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-139df671!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/DutySchedulePlan.vue
// module id = 1463
// module chunks = 1